import { Review } from '@kizi/comparator-core';
import React from 'react';
import { Field } from '..';
import { ListComp } from './List';
import { RatingComp } from './Rating';

interface ReviewsFCProps {
  review?: Review;
  title?: string;
}

export const ReviewsFC = ({ review, title = '' }: ReviewsFCProps) => {
  if (!review) return <div />;

  const { averageScore, ratings, totalReviewsCount } = review;

  let reviewsMap: Field[] = [
    {
      bold: true,
      label: `Score van ${totalReviewsCount} klanten`,
      value: averageScore.toFixed(1).replace('.', ','),
    },
  ];

  for (const reviewEl of ratings) {
    const { name, score } = reviewEl;
    reviewsMap.push({
      label: name,
      value: <RatingComp value={String(score / 2)} />,
    });
  }

  return (
    <ListComp
      groups={[
        {
          rightFieldStyle: {
            textAlign: 'left',
          },
          list: reviewsMap,
          title,
        },
      ]}
    />
  );
};
